import { useFormik } from 'formik';
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import BaseURL from '../Utilities/BaseUrl';
import axios from 'axios';
import {changeProfileValidation} from '../Utilities/Passwordvalidation';
import { toast } from 'react-toastify';
import {cartContext}from'../Contexts/CartContext';
import { Helmet } from 'react-helmet';
export default function Changeprofile({logOut}) {
  let {setcheck}=useContext(cartContext);
    const [errormesg, seterrormesg] = useState("");
    const [sucessmesg, setsucessmesg] = useState("");
    const [loading, setloading] = useState(true);
    const [disab, setdisab] = useState(true);
    let navigate = useNavigate();
  
   
     
    let Formik = useFormik({
      initialValues: {
        name: "",
        email: "",
        phone:''
      },
  validate:changeProfileValidation,
      onSubmit: (values) => {
        setloading(false);
        setdisab(false);
       let headers={
        token:localStorage.getItem('token')
       };
        axios
          .put(`${BaseURL}users/updateMe`, values,{headers}
          
          )
          .then((data) => {
            if (data.status == 200) {
              
            
              setsucessmesg(data.data.message);
              setTimeout(() => {
               
                navigate("/login");
                logOut()
              }, 1000);
            }
           
          })
          .catch((error) => {
            if (error.response.status == 401 ||error.response.status == 400 )
            {
              seterrormesg(error.response.data.message);
             
               setloading(true)
               setdisab(true)
            }
              
          });
        }
      
      })

      useEffect(() => {
        setcheck(true);
      
        
      }, [])
      
  return <>
  <Helmet>
        <title>Changeprofile</title>
        
    </Helmet>
  
 


   
    <div className="container pt-5 pb-5">
        <div className="row">
          <div className="col-12">
      <div className="loginForm">

      {errormesg !=''? 
              <div className="position-fixed top-10 end-80 p-3 mt-5 ">
              <div
                id="liveToast"
                className="toast  show  "
                role="alert"
                aria-live="assertive"
                aria-atomic="true"
              >
                <div className="toast-header position-relative  border-0 bg-danger ">
                  <button
                    type="button"
                    className="btn-close position-absolute end-0 me-2 mt-2 shadow-none"
                    data-bs-dismiss="toast"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="toast-body text-center bg-danger pb-3 fw-bold text-white">
                 Error !..  { errormesg} your email already exist
                </div>
              </div>
            </div>
             : 
              ""
            }

{sucessmesg ? 
              <div className="position-fixed top-10 end-50 p-3 mt-5 bg-sucess">
                <div
                  id="liveToast"
                  className="toast  show  "
                  role="alert"
                  aria-live="assertive"
                  aria-atomic="true"
                >
                  <div className="toast-header position-relative  border-0 bg-success">
                    <button
                      type="button"
                      className="btn-close position-absolute end-0 me-2 mt-2 shadow-none"
                      data-bs-dismiss="toast"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="toast-body text-center bg-success pb-3 fw-bold text-white">
                    {sucessmesg } your Data changed
                  </div>
                </div>
              </div>
             : 
              ""
            }
        <h2 className="mb-5">Change Profile Now .....</h2>

        <form onSubmit={Formik.handleSubmit} >
       
        <label htmlFor="name">Name :</label>
                <input
                  onChange={Formik.handleChange}
                  onBlur={Formik.handleBlur}
                  type="text"
                  name="name"
                  id="name"
                  placeholder="Enter Your Name"
                  className="form-control mt-2 w-75 mb-4 shadow-none"
                  value={Formik.values.name}
                />
                {Formik.errors.name && Formik.touched.name ? (
                  <div className="alert alert-danger w-75">
                    {Formik.errors.name}
                  </div>
                ) : (
                  ""
                )}
        <label htmlFor="email">Email :</label>
                <input
                  onChange={Formik.handleChange}
                  onBlur={Formik.handleBlur}
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Enter Your Email"
                  className="form-control mt-2 w-75 mb-4 shadow-none"
                  value={Formik.values.email}
                />
                {Formik.errors.email && Formik.touched.email ? (
                  <div className="alert alert-danger w-75">
                    {Formik.errors.email}
                  </div>
                ) : (
                  ""
                )}
                 <label htmlFor="Phone">Phone :</label>
                <input
                  onChange={Formik.handleChange}
                  onBlur={Formik.handleBlur}
                  type="text"
                  name="phone"
                  id="phone"
                  placeholder="Enter Your phone"
                  className="form-control mt-2 w-75 shadow-none"
                  value={Formik.values.phone}
                />
                {Formik.errors.phone && Formik.touched.phone ? (
                  <div className="alert alert-danger w-75">
                    {Formik.errors.phone}
                  </div>
                ) : (
                  ""
                )}
         
          <button
            type="submit"
            className="btn bg-main px-5 py-2 mt-3 text-white"
            disabled={!(Formik.isValid && Formik.dirty && disab)}
          >
            {loading ? (
              <span>Save</span>
            ) : (
              <span
                className="spinner-grow text-white "
                role="status"
                width={10}
              ></span>
            )}
          </button>
        </form>
      </div></div></div></div>
    </>
  

            }
  